module.exports = __webpack_public_path__ + "static/img/about_logo04.21b0cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/about_logo04.png
// module id = pDNf
// module chunks = 0